import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './app/App';
import { installChunkReload } from './app/chunkReload';
import { captureInstallPrompt } from './features/pwa/installPrompt';
import { VpnGate } from './features/vpnGate/VpnGate';

// Armed before the first render: a chunk can fail on the very first navigation, and the
// listener has to exist by then.
installChunkReload();

// Same reason, a different event. Chrome fires `beforeinstallprompt` once and early; miss it and
// the browser puts up its own bar instead, and the app never gets to choose when to ask.
captureInstallPrompt();

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    {/* С включённым VPN приложением пользоваться нельзя вовсе — экран стоит поверх всего,
        включая вход. См. features/vpnGate. */}
    <VpnGate>
      <App />
    </VpnGate>
  </StrictMode>,
);
